<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   let data=[
      {
         value: 60,
         name: '土地',
      },
      {
         value: 50,
         name: '种子',
      },
      {
         value: 50,
         name: '农机',
      },
      {
         value: 50,
         name: '打药',
      },{
         value: 50,
         name: '化肥',
      }
   ]

    this.state.chart.setOption({
      tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)',
        },
        legend: {
          right: '5%',
          top: 'center',
          orient: 'vertical',
          itemGap: 14,
          itemWidth: 15,
          itemHeight: 15,
         color: '#fff',
         fontSize:14,
         textStyle: {
            color: '#FBFBFB',
            fontSize: 14,
            rich: {
               0: {
                  color: '#01D1DA',
                  fontSize: 16,
                  fontWeight: 700
               },
               1: {
                  color: '#01D1DA',
                  fontSize: 14,
                  fontWeight: 700
               },
            },
         },
          formatter: function (name) {
            let than = data //获取series中的data
            let total = 0
            let tarValue
            for (let i = 0, l = than.length; i < l; i++) {
              total += than[i].value
              if (than[i].name == name) {
                tarValue = than[i].value
              }
            }
            let p = (tarValue / total) * 100
            // return ' ' + ' '+' '+name + ' ' + ' ' + ' ' + ' ' + ' '+tarValue + '次' + ' ' + ' ' + ' ' + p.toFixed(2) + '%'
            // var str = `${name}+ <span style='color:#136E78 '>${p.toFixed(1)}%</span>`
                     // ' ' + ' '+' '+name + ' ' + ' ' + ' '  +<span> p.toFixed(1) + '%'
            return ' ' + ' '+' '+name + ' ' + ' ' + ' '  +p.toFixed(1) + '%'
          },

        },
        series: [
          {
            name: '访问来源',
            type: 'pie',
            radius: '80%',
            center: ['30%', '50%'],

            color: [ '#3EB1E7', '#3CE7E7', '#E1B83A', '#25A17E','#1BCB6D'], //'#FBFE27','rgb(11,228,96)','#FE5050'
            data: [
              {
                value: 60,
                name: '土地',
              },
              {
                value: 50,
                name: '种子',
              },
              {
                value: 50,
                name: '农机',
              },
              {
                value: 50,
                name: '打药',
              },{
                value: 50,
                name: '化肥',
              }
            ].sort(function (a, b) {
              return a.value - b.value
            }),
            roseType: 'area',
            label: {
              show: false,
            },
            labelLine: {
                  color: 'rgb(98,137,169)',
                smooth: 0.2,
                length: 10,
                length2: 20,
            },
            itemStyle: {
                shadowColor: 'rgba(0,0,0,0.45); ',
                shadowBlur: 50,
            },
          },{
               name: '外边框', 
               type: 'pie',
               tooltip: {
                     show: false,
               },
               clockwise: false, //顺时加载
               emphasis:{
                  scale: false, //鼠标移入变大
               },
               radius: ['67%', '80%'],
               center: ['30%', '50%'],//这里根据自己的需要自行调整，但是两个值要一样大哦，如果小于上方设置的最小内圆30%则为内阴影，大于外圆60%则为外阴影
               label: {
                        show: false //重点：此处主要是为了不展示data中的value和name
               },
               color: 'rgba(62, 177, 231,  0.2)',
               data: [{
                     value: 1,//此处的值无所谓是多少
                     name: '',//因为不展示label，可不填
                     itemStyle: { //边框样式，此处我们设置的浅蓝色，颜色可自行修改
                           // borderWidth: 20,//边框宽度
                           // borderColor: 'rgba(94, 183, 249,  0.13)',//边框颜色
                     }
               }]
            }
        ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
